<template>
  <div class="pa-10">
    <h1>Benchmark</h1>
    <div class="d-flex">
      <div style="max-width: 300px">
        <v-list>
          <v-list-item
            link
            @click="benchmark = bm"
            v-for="bm in benchmarks"
            :key="bm.uid"
          >
            <v-list-item-title>{{ bm.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </div>
      <div v-if="benchmark" style="max-width: 600px">
        <h3>Benchmark details: {{ benchmark.title }}</h3>
        <v-btn @click="openInNewTab">Open in new tab</v-btn>
        <div class="d-flex flex-column">
          <div class="d-flex align-center mb-5" style="gap: 10px">
            <v-btn @click="addCompany">Add company</v-btn>
            <v-btn @click="saveBenchmark">save</v-btn>
          </div>
          <div class="d-flex flex-wrap" style="gap: 20px">
            <div v-for="(c, index) in benchmark?.companies" :key="index">
              <v-card class="pa-3 bg-smoke">
                <v-text-field
                  v-model="c.name"
                  label="Company name"
                ></v-text-field>
                <div
                  class="d-flex align-center"
                  style="gap: 10px; margin: 6px 0"
                >
                  <input
                    type="file"
                    accept="image/*"
                    @change="onCompanyImageChange($event, c)"
                  />
                  <span v-if="c.image" style="font-size: 12px; opacity: 0.7"
                    >Image selected</span
                  >
                  <v-img v-if="c.image" :src="c.image" width="100"></v-img>
                </div>
                <v-text-field
                  v-model="c.url"
                  label="Company url"
                ></v-text-field>
                <v-text-field
                  v-model="c.color"
                  label="Company color"
                ></v-text-field>
              </v-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { db } from "@/firebase";

import benchmarkItems from "./data/benchmark";
import { doc, updateDoc } from "firebase/firestore";

export default {
  name: "SalesBenchmark",
  data() {
    return {
      benchmark: null,
      benchmarkItems: benchmarkItems,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      benchmarks: (state) => state.benchmarks,
    }),
  },
  async mounted() {},
  methods: {
    addCompany() {
      this.benchmark.companies.push({ name: "", url: "", color: "" });
    },
    onCompanyImageChange(e, company) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.onload = () => {
          const maxW = 600;
          const maxH = 600;
          let { width, height } = img;
          const scale = Math.min(maxW / width, maxH / height, 1);
          width = Math.round(width * scale);
          height = Math.round(height * scale);

          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          // Compress to JPEG base64 (quality 0.7)
          company.image = canvas.toDataURL("image/jpeg", 0.7);
          this.$forceUpdate?.();
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    },
    async saveBenchmark() {
      this.$store.commit("setLoading", true);
      console.log(this.benchmark);
      await updateDoc(
        doc(db, "sales", "benchmarks", "neuro-ux", this.benchmark.uid),
        this.benchmark
      );
      this.$store.commit("setLoading", false);
      console.log(this.benchmark);
    },
    openInNewTab() {
      window.open(`/benchmark/${this.benchmark.uid}`, "_blank");
    },
  },
};
</script>
